"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputGS = void 0;
const gs = require("../index");
class InputGS extends gs.WrapperGS {
    static ForHTMLElement(el) {
        if (el.nodeName.toLowerCase() === "input") {
            const inputEl = el;
            return inputEl.type !== 'file';
        }
        return false;
    }
    constructor(el) {
        super(el);
    }
    get value() { return this.el.value; }
    set value(value) { this.el.value = value; }
}
exports.InputGS = InputGS;
gs.WrapperGS.ExtendComponentsByHTMLElement(InputGS);
//# sourceMappingURL=InputGS.js.map